function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M134.829 62.829L101.657 96l33.172 33.171-5.658 5.658L96 101.657 62.829 134.83l-5.658-5.658L90.343 96 57.17 62.829l5.658-5.658L96 90.343l33.171-33.172 5.658 5.658zM176 96c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zm-8 0c0-39.701-32.299-72-72-72S24 56.299 24 96s32.299 72 72 72 72-32.299 72-72z",
    style: {
      fill: "#ff0000"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldStop);
export default __webpack_public_path__ + "static/media/shield-stop.a4355f12b27926c5d555593d52c55b5a.svg";
export { ForwardRef as ReactComponent };